import {
  ChatInterface,
  FilterRequestData,
  ChatReviewFormDataInterface,
  ChatReviewInterface,
} from '@/services/QC-V2/chat/interfaces';
import { SelectUserInterface } from '@/services/Users/Interfaces';
import {
  TicketInterface,
  TicketReviewFormDataInterface,
  TicketReviewInterface,
} from '@/services/QC-V2/ticket/interfaces';

export enum EscalationPriority {
  LOW = 'low',
  NORMAL = 'normal',
  MEDIUM = 'medium',
  HIGH = 'high',
  CRITICAL = 'critical',
}

export interface EscalationPriorityInterface {
  key: string,
  value: string,
}

export enum EscalationStatus {
  OPEN = 'open',
  IN_PROGRESS = 'in-progress',
  REVIEWED = 'reviewed',
}

export interface ChatEscalationCreateData {
  chatId: string,
  escalatedFrom: string,
  departmentManager?: string
  shiftManager?: string,
  priority: EscalationPriority,
  status: EscalationStatus,
  reason: string,
  agentsIds?: string[]
}

export interface TicketEscalationCreateData {
  ticketId: number,
  escalatedFrom: string,
  departmentManager?: string
  shiftManager?: string,
  priority: EscalationPriority,
  status: EscalationStatus,
  reason: string,
  agentsIds?: string[]
}

export interface ChatEscalationInterface {
  id: number,
  escalatedFrom: string,
  departmentManager: string,
  shiftManager: string,
  reason: string,
  timestamp: string,
  priority: EscalationPriority,
  status: EscalationStatus,
  chat: ChatInterface,
}

export interface TicketEscalationInterface {
  id: number,
  escalatedFrom: string,
  departmentManager?: string,
  shiftManager?: string,
  reason: string,
  timestamp: string,
  priority: EscalationPriority,
  status: EscalationStatus,
  ticket: TicketInterface,
}

export interface EscalationDialogDataInterface {
  chat: ChatInterface,
  departmentManagers: SelectUserInterface,
  shiftManagers: SelectUserInterface,
}

export interface EscalationRepositoryInterface {
  createChatEscalation(data: ChatEscalationCreateData, reviews?: ChatReviewFormDataInterface[]): Promise<void>;

  createTicketEscalation(data: TicketEscalationCreateData, reviews?: TicketReviewFormDataInterface[]): Promise<void>;

  findAllChatEscalations(filterRequestData?: FilterRequestData): Promise<[ChatEscalationInterface[], number]>;

  findAllTicketEscalations(filterRequestData?: FilterRequestData): Promise<[TicketEscalationInterface[], number]>;

  findChatEscalationById(id: number): Promise<ChatEscalationInterface>;

  findTicketEscalationById(id: number): Promise<TicketEscalationInterface>;

  changeEscalationStatus(id: number, status: EscalationStatus): Promise<void>;

  reviewChatEscalation(id: number, reviews?: ChatReviewFormDataInterface[]): Promise<void>;

  reviewTicketEscalation(id: number, reviews?: TicketReviewFormDataInterface[]): Promise<void>;
}
